<script>
import { mapGetters, mapState } from 'vuex';
import SLSRepresentanteService from '@/services/Cadastros/ApoioVendas/SLSRepresentante.service';
import SLSClienteService from '@/services/Cadastros/Cliente/SLSCliente.service';
import {
  BButton, BCol, BOverlay, BSpinner,
} from 'bootstrap-vue';
import SLSTabelaPrecoService from '@/services/SistemaDKP/SLSTabelapreco.service';
import SLSCondicaoPagamentoService from '@/services/SistemaDKP/SLSCondicaoPagamento.service';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';
import InitialDataService from '@/services/InitialData.service';
import _ from 'lodash';
import SLSPicService from '@/services/Operacoes/SLSPic.service';
import { ocultarInfoComercialCliente, ocultarTabelaCondicaoRepresentante, ocultarTabelaCondicaoSupervisor, isPerfilClienteAtivo, PERFIS_CLIENTE } from '@/libs/perfilCliente';
import { exigirEnderecoEntrega } from '@/utils/impostoSimulador';
import EscolherEnderecoEntrega from '@/components/pedidos/EscolherEnderecoEntrega.vue';

const slsRepresentanteService = new SLSRepresentanteService();
const slsClienteService = new SLSClienteService();
const slsTabelapreco = new SLSTabelaPrecoService();
const slsCondicaoPagamentoService = new SLSCondicaoPagamentoService();
const picService = new SLSPicService();
export default {
  name: 'InfoPedido',
  components: {
    BButton, BCol, BOverlay, BSpinner, EscolherEnderecoEntrega,
  },
  watch: {
    formInfoPedido: {
      handler(value) {
        // Não commitar de volta ao Vuex aqui — formInfoPedido é um computed que lê do Vuex,
        // recomitir cria um loop infinito. As mutações via v-model já atualizam o estado.
        this.sincronizarComIntensPedido();

        if (this.$store.getters['auth/IS_LOGGED_IN']) {
          try {
            const userId = this.getUserId();
            const sessionId = InitialDataService.getSessionId();

            const cacheData = {
              ...value,
              sessionId,
              timestamp: Date.now(),
            };

            localStorage.setItem(`infoPedidoForm_${userId}`, JSON.stringify(cacheData));
          } catch (error) {
            console.error('Erro ao salvar mudanças no formulário:', error);
          }
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      isLoadingPromocoes: false,
      aguardandoEnderecoObrigatorio: false,
      isClienteFinal: false,
      isRepresentante: false,
      isOtherProfile: false, // Para perfis que não são representante nem cliente
      representantesCount: 0,
      clientesCount: 0,
    };
  },
  props: {
    bloqueado: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    picAtivo() {
      return this.$store.getters['preferencias/picAtivo'] === true;
    },
    enderecoAlternativoStore() {
      return this.$store.getters['InfoPedido/GET_ENDERECO_ALTERNATIVO'];
    },
    // CNPJ/CPF do cliente selecionado, com máscara, p/ exibição no InfoPedido.
    cnpjClienteFormatado() {
      const raw = String(this.formInfoPedido?.cliente?.clientecnpj || '').replace(/\D/g, '');
      if (!raw) return '';
      if (raw.length === 14) return raw.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
      if (raw.length === 11) return raw.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
      return String(this.formInfoPedido?.cliente?.clientecnpj || '');
    },
    // Perfil Cliente não vê o select de Tipo de Pedido (as categorias são
    // exibidas juntas no catálogo e distinguidas só na hora de adicionar).
    isPerfilCliente() {
      return isPerfilClienteAtivo();
    },
    // Preferência CLIENTE_OCULTAR_INFO_COMERCIAL: esconde (só visualmente)
    // representante, condição de pagamento e tabela de preço p/ perfil Cliente.
    ocultarInfoComercial() {
      return ocultarInfoComercialCliente(this.$store);
    },
    // Preferência REPRESENTANTE_OCULTAR_INFO_COMERCIAL: esconde (só visualmente)
    // APENAS tabela de preço e condição de pagamento p/ perfil Representante.
    ocultarTabelaCondicao() {
      return this.ocultarInfoComercial || ocultarTabelaCondicaoRepresentante(this.$store) || ocultarTabelaCondicaoSupervisor(this.$store);
    },
    clienteIdErpSemZeros: {
      get() {
        if (!this.formInfoPedido.cliente.clienteiderp) return '';
        return this.removeLeadingZeros(this.formInfoPedido.cliente.clienteiderp);
      },
      set(value) {
        this.formInfoPedido.cliente.clienteiderp = value;
      },
    },
    ...mapGetters('InfoPedido', {
      getFormInfoPedido: 'GET_FORM_INFO_PEDIDO',
      getIsLoading: 'GET_IS_LOADING',
      getLoadingRepresentante: 'GET_LOADING_REPRESENTANTE',
      getLoadingCliente: 'GET_LOADING_CLIENTE',
      getLoadingCondPagamento: 'GET_LOADING_COND_PAGAMENTO',
      getLoadingTabelaPreco: 'GET_LOADING_TABELA_PRECO',
      getTipoPedidos: 'GET_TIPO_PEDIDOS_CLIENTE',
      loadingTipoPedidos: 'GET_LOADING_TIPO_PEDIDOS',
      erroTipoPedidos: 'GET_ERRO_TIPO_PEDIDOS',
    }),
    ...mapGetters('PicStore', {
      loadingPic: 'GET_LOADING',
      IS_EXIST_PIC: 'IS_EXIST_PIC',
      picSelected: 'GET_PIC_SELECTED',
    }),
    formInfoPedido: {
      get() {
        return this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'];
      },
      set(value) {
        this.$store.commit('InfoPedido/SET_FORM_INFO_PEDIDO', value);
      },
    },
    idNexusState() {
      const v = String(this.formInfoPedido.idNexus || '');
      if (!v) return null; // sem valor: não pinta de vermelho antes do usuário digitar
      return /^\d{6}$/.test(v);
    },
    isPedidoDoacaoAtual() {
      const tipo = this.formInfoPedido?.tipoPedidoCliente?.tipopedidoid
        || this.formInfoPedido?.tipoPedido?.tipopedidoid;
      return String(tipo || '').trim().toUpperCase() === 'WD';
    },
    carrinhoComItens() {
      return this.$store.getters['PedidosStore/getTotalItensPedido'] > 0;
    },
    formBloqueado() {
      return this.carrinhoComItens;
    },
    disabledInputTabelaPreco() {
      const optionsTabelaPreco = this.$store.getters['InfoPedido/GET_OPTIONS_TABELA_PRECO'] || [];
      const tabelasPrecoSLS = this.$store.getters['SLSTabelapreco/tabelaprecos'] || [];

      const opcoes = optionsTabelaPreco.length > 0 ? optionsTabelaPreco : tabelasPrecoSLS;

      console.log('optionsTabelaPreco length:', optionsTabelaPreco.length);
      console.log('tabelasPrecoSLS length:', tabelasPrecoSLS.length);
      console.log('Opções de tabela preço usadas:', opcoes);

      return this.isClienteFinal || opcoes.length === 1;
    },
    canSearchRepresentante() {
      const podePorPerfil = this.isOtherProfile || (this.isRepresentante && this.representantesCount >= 2);
      return podePorPerfil && !this.formBloqueado && !this.bloqueado;
    },
    canSearchCliente() {
      if (this.isClienteFinal) {
        return false;
      }

      return this.formInfoPedido.representante.representanteid !== ''
             && !this.formBloqueado
             && !this.bloqueado;
    },
  },
  methods: {
    // ----- Endereço de entrega obrigatório (cliente sem endereço padrão) -----
    abrirEnderecoObrigatorio() {
      this.aguardandoEnderecoObrigatorio = true;
      this.$nextTick(() => {
        if (this.$refs.escolherEnderecoObrigatorio) this.$refs.escolherEnderecoObrigatorio.abrir();
      });
    },
    onEnderecoAlternativoEscolhido(endereco) {
      this.$store.commit('InfoPedido/SET_ENDERECO_ALTERNATIVO', endereco);
      if (endereco && endereco.uf && endereco.cidade) {
        // Espelha no enderecoEntrega do form: é dele que as simulações de
        // imposto/preço leem UF e cidade.
        this.$store.commit('InfoPedido/SET_ENDERECO_ENTREGA', {
          ...(this.formInfoPedido.enderecoEntrega || {}),
          clienteid: this.formInfoPedido.cliente?.clienteid || '',
          clienteendereco: endereco.endereco || '',
          clienteendereconumero: endereco.numero || '',
          clienteenderecocomplemento: endereco.complemento || '',
          clienteenderecobairro: endereco.bairro || '',
          clienteenderecocidade: endereco.cidade || '',
          clienteenderecocep: endereco.cep || '',
          ufid: endereco.uf || '',
        });
        this.aguardandoEnderecoObrigatorio = false;
        this.$nextTick(() => this.sincronizarComIntensPedido());
      }
    },
    async onEnderecoAlternativoFechado() {
      // Modal fechado sem escolher um endereço no fluxo obrigatório → o
      // cliente sem endereço não pode ficar selecionado (imposto não calcula).
      if (!this.aguardandoEnderecoObrigatorio) return;
      this.aguardandoEnderecoObrigatorio = false;
      if (this.enderecoAlternativoStore) return;
      await this.$store.dispatch('InfoPedido/resetarClienteInfoPedido');
      await this.$store.dispatch('intensPedido/resetDataCapaPedidoCliente');
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Endereço obrigatório',
          text: 'Este cliente não tem endereço cadastrado: para usá-lo é preciso informar o endereço de entrega. Selecione o cliente novamente para tentar de novo.',
          icon: 'AlertTriangleIcon',
          variant: 'warning',
        },
      });
    },
    onlyNumber(event) {
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode < 48 || charCode > 57) {
        event.preventDefault();
      }
    },
    // Parser seguro para JSON oriundo de storage (evita falhas intermitentes)
    safeParseJSON(value) {
      try {
        if (!value) return null;
        const trimmed = String(value).trim();
        if (!trimmed || trimmed === 'null' || trimmed === 'undefined') return null;
        return JSON.parse(trimmed);
      } catch (e) {
        return null;
      }
    },
    // Obtém o nome do perfil com fallback (localStorage, sessionStorage e store)
    getPerfilAcessoNome() {
      const lsRaw = typeof localStorage !== 'undefined' ? localStorage.getItem('perfilLogado') : null;
      const ssRaw = typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('perfilLogado') : null;
      const perfilLS = this.safeParseJSON(lsRaw);
      const perfilSS = this.safeParseJSON(ssRaw);
      const perfilObj = perfilLS || perfilSS;

      let storePerfilNome = null;
      try {
        storePerfilNome = this.$store && this.$store.getters && this.$store.getters['auth/perfilAcessoNome'];
      } catch (_) {
        storePerfilNome = null;
      }

      const fromObj = perfilObj && perfilObj.perfil_acesso_nome ? perfilObj.perfil_acesso_nome : null;

      let userDataPerfilNome = null;
      try {
        const userData = JSON.parse(localStorage.getItem('userData'));
        if (userData && Array.isArray(userData.perfils) && userData.perfils[0]) {
          userDataPerfilNome = userData.perfils[0].perfil_acesso_nome || null;
        }
      } catch (_) {}

      const nome = (fromObj || storePerfilNome || userDataPerfilNome || '').toString();
      return nome;
    },
    sincronizarComIntensPedido() {
      const formData = this.formInfoPedido;

      if (formData.cliente && formData.cliente.clienteid) {
        this.$store.commit('intensPedido/SET_IFO_CLIENTE', formData);

        this.$store.commit('intensPedido/SET_CAPA_PEDIDO', {
          clienteid: formData.cliente.clienteid,
          clienteiderp: formData.cliente.clienteiderp,
          cliente_nome: formData.cliente.clienterazaosocial,
          clientenomeabreviado: formData.cliente.clientenomeabreviado || '',
          clienteisentoie: formData.cliente.clienteisentoie || false,
          condicaopagamentoid: formData.condicaoPagamento?.condicaopagamentoid || '',
          condicaopagamentodescricao: formData.condicaoPagamento?.condicaopagamentodescricao || '',
          tabelaprecoid: formData.tabelaPreco?.tabelapreco_id || '',
          tabelapreco_descricao: formData.tabelaPreco?.tabelapreco_descricao || '',
          naturezaoperacaoid: formData.naturezaOperacao?.naturezaoperacaoid || '',
          clienteid: formData.cliente.clienteid,
          ufestabelecimento: formData.estabelecimento?.ufid || formData.estabelecimento?.ufestabelecimento || '',
          clientenatoperinterna: formData.cliente.clientenatoperinterna || '',
          clientenatoperexterna: formData.cliente.clientenatoperexterna || '',
          canalvendaid: formData.cliente?.canal_venda_id || '',
          estabelecimentoid: formData.estabelecimento?.estabelecimentoid || '',
          estabelecimentorazaosocial: formData.estabelecimento?.estabelecimentorazaosocial || '',
          representanteid: formData.representante?.representanteid || '',
          representantenome: formData.representante?.representantenome || '',
          nr_oc: formData.numeroPedidoOrderCompra || '',
          idnexus: formData.idNexus || '',
          observacoes: formData.observacao || '',
          prioridade_pedido: formData.prioridadesPedido || 1,
          tipopedidoid: formData.tipoPedidoCliente?.tipopedidoid || '',
        });

        if (formData.enderecoEntrega) {
          this.$store.commit('intensPedido/SET_ENDERECO_ENTREGA', {
            ...formData.enderecoEntrega,
            clienteid: formData.cliente.clienteid,
          });
        }
      }
    },
    removeLeadingZeros(value) {
      if (!value) return '';
      return String(value).replace(/^0+/, '');
    },
    resetEditState() {
      this.$store.commit('InfoPedido/SET_IS_LOADING', false);
      this.$store.commit('InfoPedido/SET_LOADING_CLIENTE', false);
      this.$store.commit('InfoPedido/SET_LOADING_REPRESENTANTE', false);

      // this.$store.commit('InfoPedido/SET_FORM_INFO_PEDIDO', {
      //   ...this.formInfoPedido,
      //   cliente: { clienteiderp: '', clienterazaosocial: '' },
      //   representante: { representanteid: '', representantenome: '' }
      // });
    },
    limparFormulario() {
      if (this.carrinhoComItens) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Operação bloqueada',
            text: 'Não é possível limpar o formulário com produtos no carrinho. Remova todos os itens para continuar.',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        return;
      }

      this.$bvModal.msgBoxConfirm('Tem certeza que deseja limpar todos os campos do formulário?', {
        title: 'Confirmar limpeza',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Sim, limpar',
        cancelTitle: 'Cancelar',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      })
        .then((value) => {
          if (value) {
            const perfilLogado = JSON.parse(localStorage.getItem('perfilLogado'));
            const isRepresentante = perfilLogado && perfilLogado.perfil_acesso_nome === 'Representante';

            let representanteData = null;
            if (isRepresentante) {
              representanteData = this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'].representante;
            }

            this.$store.dispatch('InfoPedido/resertInfoPedido');
            this.$store.commit('PicStore/RESET_PIC_SELECTION');

            if (isRepresentante && representanteData) {
              this.$store.commit('InfoPedido/SET_REPRESENTANTE_FORM', representanteData);
              this.$store.commit('SLSRepresentante/SET_SELECTED_REPRESENTANTE', representanteData);
              this.$store.commit('InfoPedido/SET_REPRESENTANTE_READONLY', true);
              this.$store.commit('intensPedido/SET_IFO_REPRESENTANTE', {
                representanteid: representanteData.representanteid,
                representantenome: representanteData.representantenome,
              });
            }

            if (this.$store.getters['auth/IS_LOGGED_IN']) {
              const userId = this.getUserId();

              if (isRepresentante && representanteData) {
                const sessionId = InitialDataService.getSessionId();
                const formData = {
                  ...this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'],
                  representante: representanteData,
                  sessionId,
                  timestamp: Date.now(),
                };
                localStorage.setItem(`infoPedidoForm_${userId}`, JSON.stringify(formData));
              } else {
                localStorage.removeItem(`infoPedidoForm_${userId}`);
              }
            }

            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Formulário limpo',
                text: 'Os campos foram limpos com sucesso.',
                icon: 'CheckIcon',
                variant: 'success',
              },
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getUserId() {
      try {
        const userData = JSON.parse(localStorage.getItem('userData'));
        return userData?.id || userData?.userData?.id || 'default';
      } catch (error) {
        console.error('Erro ao obter ID do usuário:', error);
        return 'default';
      }
    },
    getActiveDraftId() {
      try {
        return localStorage.getItem('activeDraftId') || null;
      } catch (e) {
        return null;
      }
    },
    shouldRestoreDraft() {
      const query = this.$route?.query || {};
      const params = this.$route?.params || {};

      const restoreFlag = String(query.restoreDraft || '').toLowerCase();
      const hasRestoreFlag = restoreFlag === '1' || restoreFlag === 'true';
      const hasDraftId = !!(query.draftId || params.draftId);

      return hasRestoreFlag || hasDraftId;
    },
    storeFormCompleto() {
      // O formulário no Vuex já está completo (carregado no login/home)?
      // Nesse caso NÃO devemos resetá-lo só porque o cache do localStorage
      // não foi encontrado — resetar apagaria estabelecimento/tabela/condição
      // e o modal abriria com campos nulos até se auto-recarregar.
      const form = this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'] || {};
      return !!(form.cliente && form.cliente.clienteid
        && form.estabelecimento && form.estabelecimento.estabelecimentoid
        && ((form.tabelaPreco && form.tabelaPreco.tabelapreco_id)
          || (form.condicaoPagamento && form.condicaoPagamento.condicaopagamentoid)));
    },
    limparDadosAnteriores() {
      if (!this.shouldRestoreDraft()) {
        const userId = this.getUserId();
        const savedFormData = localStorage.getItem(`infoPedidoForm_${userId}`);

        if (!savedFormData) {
          if (this.storeFormCompleto()) {
            console.log('Sem cache no localStorage, mas o formulário no Vuex já está completo — mantendo.');
            return;
          }
          console.log('Nenhum dado salvo encontrado. Inicializando estado padrão.');
          this.$store.dispatch('InfoPedido/resertInfoPedido');
          return;
        }

        try {
          const parsedData = JSON.parse(savedFormData);

          if (InitialDataService.isValidCache(parsedData) && Object.keys(parsedData).length > 0) {
            const { sessionId, timestamp, ...formData } = parsedData;
            this.$store.commit('InfoPedido/SET_FORM_INFO_PEDIDO', formData);

            const perfilLogado = JSON.parse(localStorage.getItem('perfilLogado'));
            const isClienteFinal = perfilLogado && PERFIS_CLIENTE.includes(perfilLogado.perfil_acesso_nome);
            const isRepresentante = perfilLogado && perfilLogado.perfil_acesso_nome === 'Representante';

            if (isClienteFinal) {
              this.$store.commit('InfoPedido/SET_CLIENTE_READONLY', true);
              this.$store.commit('InfoPedido/SET_REPRESENTANTE_READONLY', true);
            } else if (isRepresentante) {
              this.$store.commit('InfoPedido/SET_REPRESENTANTE_READONLY', true);
            }
          } else {
            console.log('Dados salvos inválidos. Inicializando estado padrão.');
            this.resetarSeIncompleto();
          }
        } catch (error) {
          console.error('Erro ao processar dados salvos:', error);
          this.resetarSeIncompleto();
        }

        return;
      }

      const activeDraftId = this.getActiveDraftId();
      if (activeDraftId) {
        try {
          const rawDraft = localStorage.getItem(`pedido_draft_${activeDraftId}`);
          if (rawDraft) {
            const draft = JSON.parse(rawDraft);
            if (draft && draft.infoPedidoSnapshot) {
              this.$store.commit('InfoPedido/SET_FORM_INFO_PEDIDO', draft.infoPedidoSnapshot);
              this.$root.$emit('info-pedido:updated', draft.infoPedidoSnapshot);
              return;
            }
          }
        } catch (e) {
          // ignora e segue
        }
      }

      const userId = this.getUserId();
      const savedFormData = localStorage.getItem(`infoPedidoForm_${userId}`);

      if (!savedFormData) {
        console.log('Nenhum dado salvo encontrado. Inicializando estado padrão.');
        this.resetarSeIncompleto();
      } else {
        try {
          const parsedData = JSON.parse(savedFormData);

          // Verificar se o cache é válido (da sessão atual)
          if (InitialDataService.isValidCache(parsedData) && Object.keys(parsedData).length > 0) {
            // console.log('Carregando dados salvos do formulário (cache válido):', parsedData);

            // Remover dados do cache antes de setar no store
            const { sessionId, timestamp, ...formData } = parsedData;
            this.$store.commit('InfoPedido/SET_FORM_INFO_PEDIDO', formData);

            const perfilLogado = JSON.parse(localStorage.getItem('perfilLogado'));
            const isClienteFinal = perfilLogado && PERFIS_CLIENTE.includes(perfilLogado.perfil_acesso_nome);
            const isRepresentante = perfilLogado && perfilLogado.perfil_acesso_nome === 'Representante';

            if (isClienteFinal) {
              this.$store.commit('InfoPedido/SET_CLIENTE_READONLY', true);
              this.$store.commit('InfoPedido/SET_REPRESENTANTE_READONLY', true);
            } else if (isRepresentante) {
              this.$store.commit('InfoPedido/SET_REPRESENTANTE_READONLY', true);
            }
          } else {
            console.log('Dados salvos inválidos. Inicializando estado padrão.');
            this.resetarSeIncompleto();
          }
        } catch (error) {
          console.error('Erro ao processar dados salvos:', error);
          this.resetarSeIncompleto();
        }
      }
    },
    resetarSeIncompleto() {
      // Só reseta o formulário se o Vuex NÃO tiver dados completos —
      // preserva o estado carregado no login/home quando o cache falta/expirou.
      if (this.storeFormCompleto()) {
        console.log('Formulário no Vuex já completo — reset ignorado.');
        return;
      }
      this.$store.dispatch('InfoPedido/resertInfoPedido');
    },
    verificarPerfilUsuario() {
      try {
        const nomePerfil = this.getPerfilAcessoNome();
        const normalized = nomePerfil ? nomePerfil.toLowerCase() : '';

        this.isRepresentante = normalized === 'representante';
        // Usa PERFIS_CLIENTE como fonte canônica (inclui ClienteHanes, PortalCliente etc.)
        this.isClienteFinal = PERFIS_CLIENTE.some((p) => p.toLowerCase() === normalized);
        this.isOtherProfile = !!normalized && !this.isRepresentante && !this.isClienteFinal;

        if (this.isRepresentante || this.isClienteFinal || this.isOtherProfile) {
          this.contarRepresentantesEClientes();
        }
      } catch (error) {
        console.error('Erro ao verificar perfil do usuário:', error);
        this.isClienteFinal = false;
        this.isRepresentante = false;
        this.isOtherProfile = false;
      }
    },
    async contarRepresentantesEClientes() {
      try {
        await this.$store.dispatch('SLSRepresentante/resertFilters');

        let representantes;
        if (this.isClienteFinal) {
          // Cliente ativo vem do vínculo usuario-cliente. Nunca consultar a rota
          // de carteira apenas para preencher/contar representante.
          const representante = this.formInfoPedido?.representante;
          representantes = representante?.representanteid ? [representante] : [];
        } else {
          representantes = await slsRepresentanteService.listarRepresentanteInfoPedido();
        }

        this.representantesCount = representantes ? representantes.length : 0;

        if (this.representantesCount === 1 && representantes[0]) {
          this.$store.commit('InfoPedido/SET_REPRESENTANTE_FORM', representantes[0]);
          this.$store.commit('SLSRepresentante/SET_SELECTED_REPRESENTANTE', representantes[0]);

          // Carregar cliente automaticamente
          // const representanteId = representantes[0].representanteid;

          // await this.$store.commit('SLSCliente/SET_FILTERS', {
          //   page: 1,
          //   perPage: 10,
          //   representanteid: representanteId
          // });

          // const clientes = await slsClienteService.listarClienteInfoPedido({ representanteid: representanteId });
          // this.clientesCount = clientes ? clientes.length : 0;

          // if (this.clientesCount === 1 && clientes[0]) {
          //   await this.info(clientes[0]);
          // }
        }
      } catch (error) {
        console.error('Erro ao contar representantes e clientes:', error);
      }
    },
    async info(item) {
      this.isLoading = true;

      this.$store.commit('InfoPedido/SET_CLIENTE_FORM', item);
      this.$store.commit('InfoPedido/SET_LOADING_CLIENTE', true);
      this.$store.commit('InfoPedido/SET_IS_LOADING', true);

      try {
        const data = await slsClienteService.getInfoPedidoNovo(item.clienteiderp);

        const [condicoesPagamento, tabelasPreco] = await Promise.all([
          slsCondicaoPagamentoService.GetCondPagtoByClienteId(data.cliente.clienteid),
          slsTabelapreco.getTabelaPrecoByClienteIdERP(data.cliente.clienteiderp),
        ]);

        // Lista de vínculos vazia NÃO limpa mais a condição/tabela quando o
        // backend já trouxe um padrão (fallback p/ clientes do ERP sem vínculo).
        if ((!Array.isArray(condicoesPagamento) || condicoesPagamento.length === 0)
          && !data.condicaoPagamento?.condicaopagamentoid) {
          console.log('Cliente não possui condições de pagamento - limpando campos');
          this.$store.commit('intensPedido/SET_CAPA_PEDIDO', {
            ...this.$store.getters['intensPedido/getFormData'].dataCapaPedido,
            condicaopagamentoid: '',
            condicaopagamentodescricao: '',
          });

          data.condicaoPagamento = {
            condicaopagamentoid: '',
            condicaopagamentodescricao: '',
          };

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Aviso',
              text: 'Não foram encontradas condições de pagamento para este cliente',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
        }

        if ((!Array.isArray(tabelasPreco) || tabelasPreco.length === 0)
          && !data.tabelaPreco?.tabelapreco_id) {
          console.log('Cliente não possui tabelas de preço - limpando campos');
          this.$store.commit('intensPedido/SET_CAPA_PEDIDO', {
            ...this.$store.getters['intensPedido/getFormData'].dataCapaPedido,
            tabelaprecoid: '',
            tabelapreco_descricao: '',
          });

          data.tabelaPreco = {
            tabelapreco_id: '',
            tabelapreco_descricao: '',
          };

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Aviso',
              text: 'Não foram encontradas tabelas de preço para este cliente',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
        }

        // Sem endereço com UF + cidade a TOTVS devolve imposto/preço zerados.
        // Cliente sem endereço → o usuário é OBRIGADO a informar o endereço de
        // entrega agora (ou trocar de cliente).
        const decisaoEndereco = await exigirEnderecoEntrega(data);
        if (decisaoEndereco === 'trocar') {
          await this.$store.dispatch('InfoPedido/resetarClienteInfoPedido');
          await this.$store.dispatch('intensPedido/resetDataCapaPedidoCliente');
          return;
        }

        const representanteAtual = { ...this.formInfoPedido.representante };

        this.$store.commit('InfoPedido/SET_CLIENTE_DATA', {
          clienteData: data,
          enderecoEntrega: data.enderecoEntrega,
          dataCapaPedido: {
            estabelecimentoid: data.estabelecimento.estabelecimentoid,
            clientenomeabreviado: data.cliente.clientenomeabreviado,
            naturezaoperacaoid: data.naturezaOperacao?.naturezaoperacaoid || '',
            canal_venda_id: data.cliente.canal_venda_id,
            clienteisentoie: data.cliente.clienteisentoie,
            tabelaprecoid: data.tabelaPreco?.tabelapreco_id || '',
            condicaopagamentoid: data.condicaoPagamento?.condicaopagamentoid || '',
          },
        });

        const condicaoPagamentoAtual = this.formInfoPedido.condicaoPagamento;

        this.$store.commit('InfoPedido/SET_FORM_INFO_PEDIDO', {
          ...data,
          representante: representanteAtual,
          condicaoPagamento: condicaoPagamentoAtual && condicaoPagamentoAtual.condicaopagamentoid
            ? condicaoPagamentoAtual
            : data.condicaoPagamento,
        });

        if (this.formInfoPedido.cliente?.clienteid
          && this.formInfoPedido.estabelecimento?.estabelecimentoid
          && (this.formInfoPedido.tabelaPreco?.tabelapreco_id || this.formInfoPedido.condicaoPagamento?.condicaopagamentoid)) {
          this.$store.commit('PicStore/SET_FILTERS', {
            clienteid: this.formInfoPedido.cliente.clienteid,
            estabelecimentoid: this.formInfoPedido.estabelecimento.estabelecimentoid,
            tabelaprecoId: this.formInfoPedido.tabelaPreco?.tabelapreco_id || null,
            condicaopagamentoid: this.formInfoPedido.condicaoPagamento?.condicaopagamentoid || null,
          });
        }

        this.$nextTick(() => {
          this.sincronizarComIntensPedido();
        });

        if (decisaoEndereco === 'escolher') this.abrirEnderecoObrigatorio();
      } catch (error) {
        this.$store.dispatch('InfoPedido/resertInfoPedido');
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro ao buscar cliente',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        });
      } finally {
        this.$store.commit('InfoPedido/SET_LOADING_CLIENTE', false);
        this.$store.commit('InfoPedido/SET_IS_LOADING', false);
        this.isLoading = false;
      }
    },
    async loadingRepresentantes() {
      // Se for ClienteFinal com apenas um representante, não permitir buscar
      if (this.isClienteFinal && this.representantesCount <= 1) {
        return;
      }

      await this.$store.dispatch('SLSRepresentante/resertFilters');
      await this.$store.dispatch('SLSRepresentante/listarRepresentanteInfoPedido');
    },
    async loadingClientes() {
      const { representanteid } = this.formInfoPedido.representante;
      if (this.isClienteFinal && this.clientesCount <= 1) {
        return;
      }

      await slsClienteService.listarClienteInfoPedido({ representanteid });
    },
    async loadFirstClienteForRepresentante() {
      // try {
      //   const representanteid = this.formInfoPedido.representante.representanteid;
      //   if (!representanteid) return;

      //   this.$store.commit('InfoPedido/SET_IS_LOADING', true);
      //   this.$store.commit('InfoPedido/SET_LOADING_CLIENTE', true);

      //   const representanteAtual = { ...this.formInfoPedido.representante };
      //   // const condicaoPagamentoAtual = { ...this.formInfoPedido.condicaoPagamento };

      //   this.$store.commit('SLSCliente/SET_FILTERS', {
      //     page: 1,
      //     perPage: 1,
      //     representanteid: representanteid
      //   });

      //   const clientes = await slsClienteService.listarClienteInfoPedido({ representanteid: representanteid });

      //   if (clientes && clientes.length > 0) {
      //     this.isLoading = true;
      //     this.$store.commit('InfoPedido/SET_CLIENTE_FORM', clientes[0]);

      //     await slsClienteService.getInfoPedidoByClienteId(clientes[0].clienteiderp)
      //       .then(async data => {
      //         this.$store.commit('InfoPedido/SET_CLIENTE_DATA', {
      //           clienteData: data,
      //           enderecoEntrega: data.enderecoEntrega,
      //           dataCapaPedido: {
      //             estabelecimentoid: data.estabelecimento.estabelecimentoid,
      //             clientenomeabreviado: data.cliente.clientenomeabreviado,
      //             naturezaoperacaoid: data.cliente.naturezaoperacaoid,
      //             canal_venda_id: data.cliente.canal_venda_id,
      //             clienteisentoie: data.cliente.clienteisentoie,
      //             tabelaprecoid: data.tabelaPreco.tabelapreco_id,
      //             condicaopagamentoid: data.condicaoPagamento.condicaopagamentoid
      //           }
      //         });

      //         const condicaoPagamentoAtual = this.formInfoPedido.condicaoPagamento;

      //         this.$store.commit('InfoPedido/SET_FORM_INFO_PEDIDO', {
      //           ...data,
      //           representante: representanteAtual,
      //           condicaoPagamento: condicaoPagamentoAtual && condicaoPagamentoAtual.condicaopagamentoid
      //             ? condicaoPagamentoAtual
      //             : data.condicaoPagamento
      //         });

      //         if (this.$store.getters['auth/IS_LOGGED_IN']) {
      //           const updatedFormData = this.$store.getters["InfoPedido/GET_FORM_INFO_PEDIDO"];
      //           const userData = JSON.parse(localStorage.getItem('userData'));
      //           const userId = userData?.id || 'default';
      //           localStorage.setItem(`infoPedidoForm_${userId}`, JSON.stringify(updatedFormData));
      //         }
      //       });
      //   } else {
      //     await this.$store.dispatch('InfoPedido/resetarClienteInfoPedido');
      //     this.formInfoPedido = { ...this.$store.getters["InfoPedido/GET_FORM_INFO_PEDIDO"] };

      //     const formResetado = this.$store.getters["InfoPedido/GET_FORM_INFO_PEDIDO"];
      //     this.$store.commit('InfoPedido/SET_FORM_INFO_PEDIDO', {
      //       ...formResetado,
      //       representante: representanteAtual,
      //       condicaoPagamento: {
      //         condicaopagamentoid: null,
      //         condicaopagamentodescricao: null
      //       },
      //       tabelaPreco: {
      //         tabelapreco_id: null,
      //         tabelapreco_descricao: null
      //       }
      //     });

      //     this.$store.commit('PicStore/RESET_PIC_SELECTION');

      //     this.$toast({
      //       component: ToastificationContent,
      //       props: {
      //         title: 'Nenhum cliente encontrado para o representante selecionado.',
      //         text: 'Verifique se o representante possui clientes vinculados ou revise os filtros aplicados.',
      //         icon: 'AlertTriangleIcon',
      //         variant: 'warning',
      //       },
      //     });

      //     if (this.$store.getters['auth/IS_LOGGED_IN']) {
      //       const updatedFormData = this.$store.getters["InfoPedido/GET_FORM_INFO_PEDIDO"];
      //       const userData = JSON.parse(localStorage.getItem('userData'));
      //       const userId = userData?.id || 'default';
      //       localStorage.setItem(`infoPedidoForm_${userId}`, JSON.stringify(updatedFormData));
      //     }
      //   }
      // } catch (error) {
      //   console.error('Erro ao carregar primeiro cliente para o representante:', error);

      //   await this.$store.dispatch('InfoPedido/resetarClienteInfoPedido');
      //   this.formInfoPedido = { ...this.$store.getters["InfoPedido/GET_FORM_INFO_PEDIDO"] };

      //   this.$toast({
      //     component: ToastificationContent,
      //     props: {
      //       title: 'Erro',
      //       text: 'Erro ao carregar dados do cliente',
      //       icon: 'AlertCircleIcon',
      //       variant: 'danger',
      //     },
      //   });
      // } finally {
      //   this.$store.commit('InfoPedido/SET_LOADING_CLIENTE', false);
      //   this.$store.commit('InfoPedido/SET_IS_LOADING', false);
      //   this.$store.commit('InfoPedido/SET_LOADING_REPRESENTANTE', false);
      //   this.isLoading = false;
      // }
      console.log('Representante alterado, mas o carregamento automático de cliente está desativado');
    },
    updateFormInfoPedido() {
      this.$store.commit('InfoPedido/SET_FORM_INFO_PEDIDO', this.formInfoPedido);
    },
    // Métodos com debounce
    onChagenClienteDebounced: _.debounce(function () {
      this.onChagenCliente();
    }, 300),
    onChageCodigoTabelaPrecoDebounced: _.debounce(function (event) {
      this.onChageCodigoTabelaPreco(event);
    }, 300),
    onChangeCondPagtoDebounced: _.debounce(function (event) {
      this.onChangeCondPagto(event);
    }, 300),
    async loadingRepresentantes() {
      if (this.isClienteFinal) {
        return;
      }

      try {
        this.$store.commit('InfoPedido/SET_LOADING_REPRESENTANTE', true);

        await this.$store.dispatch('SLSRepresentante/resertFilters');

        this.$store.commit('SLSRepresentante/SET_FILTERS_PER_PAGE', 1000);
        await this.$store.dispatch('SLSRepresentante/listarRepresentanteInfoPedido');
      } catch (error) {
        console.error('Erro ao carregar representantes:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Falha ao carregar a lista de representantes',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        });
      } finally {
        this.$store.commit('InfoPedido/SET_LOADING_REPRESENTANTE', false);
      }
    },
    async loadingClientes() {
      const { representanteid } = this.formInfoPedido.representante;
      if (this.isClienteFinal && this.clientesCount <= 1) {
        return;
      }

      if (!representanteid) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Aviso',
            text: 'Selecione um representante antes de buscar clientes',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        return;
      }

      await slsClienteService.listarClienteInfoPedido({
        representanteid,
        perPage: 100000000,
      });
    },
    async onChageCodigoRepresentante() {
      this.$store.commit('PicStore/RESET_PIC_SELECTION');
      this.$store.commit('InfoPedido/SET_LOADING_REPRESENTANTE', true);

      await this.$store.dispatch('InfoPedido/resetarClienteInfoPedido');

      if (!this.formInfoPedido.representante.representanteid) {
        this.$store.commit('InfoPedido/SET_LOADING_REPRESENTANTE', false);
        return;
      }

      try {
        await this.$store.dispatch('SLSRepresentante/resertFilters');
        this.$store.commit('SLSRepresentante/SET_FILTERS_REPRESENTANTE_ID', this.formInfoPedido.representante.representanteid);
        this.$store.commit('SLSRepresentante/SET_FILTERS_PER_PAGE', 1);

        const response = await slsRepresentanteService.listarRepresentanteInfoPedido();

        if (response && response.success === false) {
          const representanteId = this.formInfoPedido.representante.representanteid;

          await this.$store.dispatch('InfoPedido/resertInfoPedido');

          this.$store.commit('InfoPedido/SET_REPRESENTANTE_FORM', {
            representanteid: representanteId,
            representantenome: '',
          });

          this.$store.commit('PicStore/RESET_PIC_SELECTION');
          this.$store.commit('SLSCliente/SET_FILTERS_CLIENTE_ID', null);

          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.title || 'Aviso',
              text: response.message || 'O representante informado não está disponível.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          return;
        }

        if (response && response.length > 0) {
          const representante = response[0];

          this.$store.commit('InfoPedido/SET_REPRESENTANTE_FORM', representante);
          this.$store.commit('SLSRepresentante/SET_SELECTED_REPRESENTANTE', representante);
          this.$store.commit('intensPedido/SET_IFO_REPRESENTANTE', {
            representanteid: representante.representanteid,
            representantenome: representante.representantenome,
          });

          setTimeout(() => {
            this.$root.$emit('representante:changed', representante.representanteid);
          }, 100);
        } else {
          const representanteId = this.formInfoPedido.representante.representanteid;

          await this.$store.dispatch('InfoPedido/resertInfoPedido');

          this.$store.commit('InfoPedido/SET_REPRESENTANTE_FORM', {
            representanteid: representanteId,
            representantenome: '',
          });

          this.$store.commit('PicStore/RESET_PIC_SELECTION');
          this.$store.commit('SLSCliente/SET_FILTERS_CLIENTE_ID', null);

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Representante não encontrado',
              text: 'Não foi encontrado nenhum representante com este código. Os campos foram limpos.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
        }
      } catch (error) {
        console.error('Erro ao buscar representante:', error);

        if (error.response && error.response.data) {
          const errorData = error.response.data;

          if (errorData.success === false) {
            const representanteId = this.formInfoPedido.representante.representanteid;
            await this.$store.dispatch('InfoPedido/resertInfoPedido');

            this.$store.commit('InfoPedido/SET_REPRESENTANTE_FORM', {
              representanteid: representanteId,
              representantenome: '',
            });

            this.$toast({
              component: ToastificationContent,
              props: {
                title: errorData.title || 'Aviso',
                text: errorData.message || 'O representante informado não está disponível.',
                icon: 'AlertTriangleIcon',
                variant: 'warning',
              },
            });
            return;
          }
        }

        const representanteId = this.formInfoPedido.representante.representanteid;
        await this.$store.dispatch('InfoPedido/resertInfoPedido');

        this.$store.commit('InfoPedido/SET_REPRESENTANTE_FORM', {
          representanteid: representanteId,
          representantenome: '',
        });

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Ocorreu um erro ao buscar o representante. Os campos foram limpos.',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        });
      } finally {
        this.$store.commit('InfoPedido/SET_LOADING_REPRESENTANTE', false);
      }
    },
    getPromocoes() {
      if (!this.picAtivo || this.isLoadingPromocoes) return;
      this.isLoadingPromocoes = true;

      const formData = this.formInfoPedido;

      if (!formData.estabelecimento?.estabelecimentoid) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Aviso',
            text: 'Estabelecimento não informado!',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        this.isLoadingPromocoes = false;
        return;
      }

      if (!formData.cliente?.clienteid) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Aviso',
            text: 'Cliente não informado!',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        this.isLoadingPromocoes = false;
        return;
      }

      if (!formData.tabelaPreco?.tabelapreco_id) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Aviso',
            text: 'Tabela de preço não informada!',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        this.isLoadingPromocoes = false;
        return;
      }

      if (this.$store.getters['preferencias/condicaoPagamentoAtiva'] && !formData.condicaoPagamento?.condicaopagamentoid) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Aviso',
            text: 'Condição de pagamento não informada!',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        this.isLoadingPromocoes = false;
        return;
      }

      this.$store.commit('PicStore/SET_FILTERS', {
        estabelecimentoid: formData.estabelecimento.estabelecimentoid,
        clienteid: formData.cliente.clienteid,
        tabelaprecoId: formData.tabelaPreco.tabelapreco_id,
        condicaopagamentoid: formData.condicaoPagamento.condicaopagamentoid,
      });

      picService.getPicPedidos().then((result) => {
        if (this.$store.getters['PicStore/IS_EXIST_PIC']) {
          this.opemenModalPic();
        }
        if (!this.$store.getters['PicStore/IS_EXIST_PIC']) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Aviso',
              text: 'Nenhuma promoção encontrada para o cliente e representante selecionados!',
              icon: 'LoaderIcon',
              variant: 'info',
            },
          });
        }
      }).catch((error) => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Erro ao buscar promoções!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      }).finally(() => {
        this.isLoadingPromocoes = false;
      });
    },
    async onChagenCliente() {
      this.$store.commit('PicStore/RESET_PIC_SELECTION');

      const clienteIdErp = this.formInfoPedido.cliente.clienteiderp;
      const representanteId = this.formInfoPedido.representante.representanteid;
      // const savedClienteIdErp = this.$store.getters["InfoPedido/GET_FORM_INFO_PEDIDO"].cliente.clienteiderp;

      if (!clienteIdErp) {
        await this.$store.dispatch('InfoPedido/resetarClienteInfoPedido');
        this.formInfoPedido = { ...this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'] };
        return;
      }

      if (!this.formInfoPedido.cliente.clienteiderp) {
        await this.$store.dispatch('InfoPedido/resetarClienteInfoPedido');
        this.formInfoPedido = { ...this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'] };
        return;
      }

      try {
        let clientes;

        if (!representanteId) {
          await this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Representante obrigatório',
              text: 'Selecione um representante antes de informar o cliente',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });

          await this.$store.dispatch('InfoPedido/resetarClienteInfoPedido');
          this.formInfoPedido = { ...this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'] };
          return;
        }

        if (this.isRepresentante || this.isOtherProfile) {
          clientes = await slsClienteService.listarClientePorRepresentante(representanteId, {
            perPage: 100000000,
          });
        } else {
          const params = {
            representanteid: representanteId,
            perPage: 100000000,
          };
          clientes = await slsClienteService.listarClienteInfoPedido(params);
        }

        if (!Array.isArray(clientes) || clientes.length === 0) {
          await this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Cliente não encontrado',
              text: 'Tente novamente.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });

          await this.$store.dispatch('InfoPedido/resetarClienteInfoPedido');
          this.formInfoPedido = { ...this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'] };
          return;
        }

        const clienteIdErpSemZeros = this.removeLeadingZeros(clienteIdErp);
        const clienteEncontrado = clientes.find((c) => this.removeLeadingZeros(c.clienteiderp) === clienteIdErpSemZeros);

        if (!clienteEncontrado) {
          await this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Cliente não encontrado',
              text: 'Tente novamente.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          await this.$store.dispatch('InfoPedido/resetarClienteInfoPedido');
          this.formInfoPedido = { ...this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'] };
          return;
        }

        this.$store.commit('InfoPedido/SET_LOADING_CLIENTE', true);
        this.$store.commit('InfoPedido/SET_IS_LOADING', true);

        let data;
        if (this.isRepresentante || this.isOtherProfile) {
          data = await slsClienteService.getInfoPedidoNovo(clienteIdErp);
        } else {
          data = await slsClienteService.getInfoPedidoByClienteId(clienteIdErp);
        }

        if (data) {
          if (this.formInfoPedido.representante && this.formInfoPedido.representante.representanteid
            && data.representante && data.representante.representanteid !== this.formInfoPedido.representante.representanteid) {
            await this.$store.dispatch('InfoPedido/resetarClienteInfoPedido');
            this.formInfoPedido = { ...this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'] };

            await this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Cliente não encontrado',
                text: 'Tente novamente.',
                icon: 'AlertTriangleIcon',
                variant: 'warning',
              },
            });

            this.$store.commit('InfoPedido/SET_CLIENTE_FORM', {
              clienteiderp: this.formInfoPedido.cliente.clienteiderp,
              clienterazaosocial: '',
            });

            return;
          }

          // Sem endereço com UF + cidade a TOTVS devolve imposto/preço zerados.
          // Cliente sem endereço → o usuário é OBRIGADO a informar o endereço de
          // entrega agora (ou trocar de cliente).
          const decisaoEndereco = await exigirEnderecoEntrega(data);
          if (decisaoEndereco === 'trocar') {
            await this.$store.dispatch('InfoPedido/resetarClienteInfoPedido');
            await this.$store.dispatch('intensPedido/resetDataCapaPedidoCliente');
            this.formInfoPedido = { ...this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'] };
            return;
          }
          if (decisaoEndereco === 'escolher') this.abrirEnderecoObrigatorio();

          const [condicoesPagamento, tabelasPreco] = await Promise.all([
            slsCondicaoPagamentoService.GetCondPagtoByClienteId(data.cliente.clienteid),
            slsTabelapreco.getTabelaPrecoByClienteIdERP(data.cliente.clienteiderp),
          ]);

          // Lista de vínculos vazia NÃO limpa mais a condição/tabela quando o
          // backend já trouxe um padrão (fallback p/ clientes do ERP sem vínculo).
          if ((!Array.isArray(condicoesPagamento) || condicoesPagamento.length === 0)
            && !data.condicaoPagamento?.condicaopagamentoid) {
            console.log('Cliente não possui condições de pagamento - limpando campos');
            this.$store.commit('intensPedido/SET_CAPA_PEDIDO', {
              ...this.$store.getters['intensPedido/getFormData'].dataCapaPedido,
              condicaopagamentoid: '',
              condicaopagamentodescricao: '',
            });

            data.condicaoPagamento = {
              condicaopagamentoid: '',
              condicaopagamentodescricao: '',
            };

            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Aviso',
                text: 'Não foram encontradas condições de pagamento para este cliente',
                icon: 'AlertTriangleIcon',
                variant: 'warning',
              },
            });
          }

          if ((!Array.isArray(tabelasPreco) || tabelasPreco.length === 0)
            && !data.tabelaPreco?.tabelapreco_id) {
            console.log('Cliente não possui tabelas de preço - limpando campos');
            this.$store.commit('intensPedido/SET_CAPA_PEDIDO', {
              ...this.$store.getters['intensPedido/getFormData'].dataCapaPedido,
              tabelaprecoid: '',
              tabelapreco_descricao: '',
            });

            data.tabelaPreco = {
              tabelapreco_id: '',
              tabelapreco_descricao: '',
            };

            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Aviso',
                text: 'Não foram encontradas tabelas de preço para este cliente',
                icon: 'AlertTriangleIcon',
                variant: 'warning',
              },
            });
          }

          if (data.cliente && data.cliente.tabelaprecoid && data.optionsTabelaPrecoCliente && data.optionsTabelaPrecoCliente.length > 0) {
            const tabelaPrecoPrincipal = data.optionsTabelaPrecoCliente.find(
              (tabela) => tabela.tabelapreco_id === data.cliente.tabelaprecoid,
            );

            if (tabelaPrecoPrincipal) {
              console.log('Tabela de preço principal encontrada nas opções:', tabelaPrecoPrincipal);
              data.tabelaPreco = {
                tabelapreco_id: tabelaPrecoPrincipal.tabelapreco_id,
                tabelapreco_descricao: tabelaPrecoPrincipal.tabelapreco_descricao,
              };
            } else {
              console.log('Tabela de preço principal não está disponível nas opções');
            }
          }

          this.$store.commit('InfoPedido/SET_CLIENTE_DATA', {
            clienteData: data,
            enderecoEntrega: data.enderecoEntrega,
            dataCapaPedido: {
              estabelecimentoid: data.estabelecimento.estabelecimentoid,
              clientenomeabreviado: data.cliente.clientenomeabreviado,
              naturezaoperacaoid: data.naturezaOperacao?.naturezaoperacaoid || '',
              canal_venda_id: data.cliente.canal_venda_id,
              clienteisentoie: data.cliente.clienteisentoie,
              tabelaprecoid: data.tabelaPreco?.tabelapreco_id || '',
              condicaopagamentoid: data.condicaoPagamento?.condicaopagamentoid || '',
            },
          });

          this.$store.commit('InfoPedido/SET_FORM_INFO_PEDIDO', {
            representante: this.formInfoPedido.representante,
            ...data,
          });

          if (data.cliente?.clienteid
            && data.estabelecimento?.estabelecimentoid
            && (data.tabelaPreco?.tabelapreco_id || data.condicaoPagamento?.condicaopagamentoid)) {
            this.isLoadingPromocoes = true;
            this.$store.commit('PicStore/SET_FILTERS', {
              clienteid: data.cliente.clienteid,
              estabelecimentoid: data.estabelecimento.estabelecimentoid,
              tabelaprecoId: data.tabelaPreco?.tabelapreco_id || null,
              condicaopagamentoid: data.condicaoPagamento?.condicaopagamentoid || null,
            });
          }
        } else {
          await this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Cliente não encontrado',
              text: 'Não foi possível encontrar o cliente informado.',
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          });
        }
      } catch (error) {
        console.log('error', error);
        this.$store.dispatch('InfoPedido/resertInfoPedido');

        await this.$toast({
          component: ToastificationContent,
          props: {
            title: error.response?.data?.title || 'Erro',
            text: error.response?.data?.message || 'Erro ao buscar cliente',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        });
      } finally {
        this.$store.commit('InfoPedido/SET_LOADING_CLIENTE', false);
        this.$store.commit('InfoPedido/SET_IS_LOADING', false);
        this.isLoadingPromocoes = false;
      }
    },
    async onChageCodigoTabelaPreco(event) {
      const codTabelaPreco = typeof event === 'object' && event.target
        ? event.target.value
        : this.formInfoPedido.tabelaPreco.tabelapreco_id;

      this.$store.commit('PicStore/SET_FILTERS_TABELAPRECO_ID', codTabelaPreco);

      if (!codTabelaPreco || !codTabelaPreco.length) {
        this.$store.commit('InfoPedido/SET_TABELA_PRECO', {
          tabelapreco_id: null,
          tabelapreco_descricao: null,
        });
        return;
      }

      this.$store.commit('InfoPedido/SET_LOADING_TABELA_PRECO', true);

      try {
        const clienteIdERP = this.formInfoPedido.cliente.clienteiderp;
        if (!clienteIdERP) {
          await this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Cliente não selecionado',
              text: 'Selecione um cliente antes de definir a tabela de preço.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          return;
        }

        const tabelasPreco = await slsTabelapreco.getTabelaPrecoByClienteIdERP(clienteIdERP);

        if (!Array.isArray(tabelasPreco) || tabelasPreco.length === 0) {
          this.$store.commit('InfoPedido/SET_TABELA_PRECO', {
            tabelapreco_id: '',
            tabelapreco_descricao: '',
          });

          this.$store.commit('intensPedido/SET_CAPA_PEDIDO', {
            ...this.$store.getters['intensPedido/getFormData'].dataCapaPedido,
            tabelaprecoid: '',
            tabelapreco_descricao: '',
          });

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Aviso',
              text: 'Não foram encontradas tabelas de preço para este cliente',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          return;
        }

        const currentTabelaPreco = tabelasPreco.find(
          (tabelaPreco) => String(tabelaPreco.tabelapreco_id).toUpperCase() === String(codTabelaPreco).toUpperCase(),
        );

        if (!currentTabelaPreco) {
          await this.$store.dispatch('InfoPedido/resetarTabelaPrecoInfoPedido');
          await this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Tabela de preço não encontrada',
              text: 'A tabela de preço informada não foi encontrada, por favor, verifique o código informado!',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          return;
        }

        this.$store.commit('InfoPedido/SET_TABELA_PRECO', currentTabelaPreco);
      } catch (error) {
        console.error('Erro ao buscar tabela de preço:', error);
        await this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Ocorreu um erro ao buscar a tabela de preço. Tente novamente.',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        });
      } finally {
        this.$store.commit('InfoPedido/SET_LOADING_TABELA_PRECO', false);
      }
    },
    async onChangeCondPagto(event) {
      this.$store.commit('PicStore/RESET_PIC_SELECTION');

      const codigoCondPagto = typeof event === 'object' && event.target
        ? String(event.target.value).trim()
        : String(this.formInfoPedido.condicaoPagamento.condicaopagamentoid || '').trim();

      console.log('onChangeCondPagto - código digitado:', codigoCondPagto);

      if (!codigoCondPagto) {
        console.log('Código de condição de pagamento vazio, resetando valores');
        this.$store.commit('InfoPedido/SET_CONDICAO_PAGAMENTO_FORM', {
          condicaopagamentoid: null,
          condicaopagamentodescricao: null,
        });
        this.$store.commit('PicStore/SET_FILTERS_CONDICAOPAGAMENTO_ID', null);
        await picService.getPicPedidos();
        return;
      }

      try {
        console.log('Buscando condição de pagamento:', codigoCondPagto);
        this.$store.commit('InfoPedido/SET_LOADING_COND_PAGAMENTO', true);

        const clienteId = this.formInfoPedido.cliente.clienteid;
        if (!clienteId) {
          console.log('Cliente não selecionado');
          await this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Cliente não selecionado',
              text: 'Selecione um cliente antes de definir a condição de pagamento.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          return;
        }

        console.log('Buscando condições de pagamento para cliente ID:', clienteId);
        const allCondPgtoCliente = this.$store.getters['InfoPedido/GET_OPTIONS_COND_PAGAMENTO']?.length
          ? this.$store.getters['InfoPedido/GET_OPTIONS_COND_PAGAMENTO']
          : await slsCondicaoPagamentoService.GetCondPagtoByClienteId(clienteId, { perPage: 8000000 });

        if (!Array.isArray(allCondPgtoCliente) || allCondPgtoCliente.length === 0) {
          console.log('Cliente não possui condições de pagamento');
          this.$store.commit('InfoPedido/SET_CONDICAO_PAGAMENTO_FORM', {
            condicaopagamentoid: '',
            condicaopagamentodescricao: '',
          });

          this.$store.commit('intensPedido/SET_CAPA_PEDIDO', {
            ...this.$store.getters['intensPedido/getFormData'].dataCapaPedido,
            condicaopagamentoid: '',
            condicaopagamentodescricao: '',
          });

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Aviso',
              text: 'Não foram encontradas condições de pagamento para este cliente',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          return;
        }

        console.log('Condições encontradas:', allCondPgtoCliente);

        const existCondPagto = allCondPgtoCliente.find(
          (condPgto) => String(condPgto.condicaopagamentoid).trim() === codigoCondPagto,
        );

        if (existCondPagto) {
          console.log('Condição de pagamento encontrada:', existCondPagto);
          this.$store.commit('InfoPedido/SET_OPTIONS_COND_PAGAMENTO', allCondPgtoCliente);

          this.$store.commit('InfoPedido/SET_CONDICAO_PAGAMENTO_FORM', {
            condicaopagamentoid: existCondPagto.condicaopagamentoid,
            condicaopagamentodescricao: existCondPagto.condicaopagamentodescricao,
          });

          this.$store.commit('PicStore/SET_FILTERS_CONDICAOPAGAMENTO_ID', existCondPagto.condicaopagamentoid);

          this.$nextTick(() => {
            console.log('Valores atualizados:', this.formInfoPedido.condicaoPagamento);
          });

          await picService.getPicPedidos();
        } else {
          console.log('Condição de pagamento não encontrada');
          await this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Condição de pagamento não encontrada',
              text: 'Não encontrada condição de pagamento para o cliente!',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          this.$store.commit('InfoPedido/SET_CONDICAO_PAGAMENTO_FORM', {
            condicaopagamentoid: '',
            condicaopagamentodescricao: '',
          });
        }
      } catch (error) {
        console.error('Erro ao buscar condição de pagamento:', error);
        await this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Erro ao buscar a condição de pagamento. Tente novamente.',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        });
      } finally {
        this.$store.commit('InfoPedido/SET_LOADING_COND_PAGAMENTO', false);
      }
    },
    opemenModalPic() {
      if (!this.picAtivo) return;
      this.$root.$emit('openModal:pic', {
        type: 'info-pedido',
        operacao: 'create',
        data: null,
      });
    },
  },
  beforeDestroy() {
    this.$root.$off('endereco-obrigatorio:abrir', this.abrirEnderecoObrigatorio);
  },
  async mounted() {
    this.verificarPerfilUsuario();
    this.limparDadosAnteriores();

    // Cliente sem endereço selecionado pelo ModalBuscarCliente → o modal
    // obrigatório de endereço é renderizado aqui.
    this.$root.$on('endereco-obrigatorio:abrir', this.abrirEnderecoObrigatorio);

    // All permitted-type reads go through the store so a late response cannot
    // replace the options of a newer load/profile. No local copy of the form.
    this.$store.dispatch('InfoPedido/carregarTiposPedidoPermitidos');

    const perfilLogado = JSON.parse(localStorage.getItem('perfilLogado'));
    if (perfilLogado) {
      if (PERFIS_CLIENTE.includes(perfilLogado.perfil_acesso_nome)) {
        const clienteData = JSON.parse(localStorage.getItem('clienteData'));
        if (clienteData) {
          console.log('Usando dados de cliente armazenados no localStorage');

          if (clienteData.cliente) {
            this.$store.commit('InfoPedido/SET_CLIENTE_FORM', clienteData.cliente);
            this.$store.commit('InfoPedido/SET_CLIENTE_READONLY', true);
          }

          if (clienteData.representante) {
            this.$store.commit('InfoPedido/SET_REPRESENTANTE_FORM', clienteData.representante);
            this.$store.commit('SLSRepresentante/SET_SELECTED_REPRESENTANTE', clienteData.representante);
            this.$store.commit('InfoPedido/SET_REPRESENTANTE_READONLY', true);
            this.$store.commit('intensPedido/SET_IFO_REPRESENTANTE', {
              representanteid: clienteData.representante.representanteid,
              representantenome: clienteData.representante.representantenome,
            });
          }

          this.formInfoPedido = { ...this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'] };
        }
      } else if (perfilLogado.perfil_acesso_nome === 'Representante') {
        const representanteData = JSON.parse(localStorage.getItem('representanteData'));
        if (representanteData) {
          console.log('Usando dados de representante armazenados no localStorage');

          this.$store.commit('InfoPedido/SET_REPRESENTANTE_FORM', representanteData);
          this.$store.commit('SLSRepresentante/SET_SELECTED_REPRESENTANTE', representanteData);
          this.$store.commit('InfoPedido/SET_REPRESENTANTE_READONLY', true);
          this.$store.commit('intensPedido/SET_IFO_REPRESENTANTE', {
            representanteid: representanteData.representanteid,
            representantenome: representanteData.representantenome,
          });

          this.formInfoPedido = { ...this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'] };
        }
      }
    }

    this.$root.$on('representante:changed', async (representanteId) => {
      // await this.loadFirstClienteForRepresentante();
      console.log('Representante alterado:', representanteId);
    });

    this.$root.$on('condpagto:selected', async (condPagto) => {
      console.log('Evento condpagto:selected recebido:', condPagto);
      if (condPagto && condPagto.condicaopagamentoid) {
        this.$store.commit('InfoPedido/SET_CONDICAO_PAGAMENTO_FORM', condPagto);
        this.$store.commit('PicStore/SET_FILTERS_CONDICAOPAGAMENTO_ID', condPagto.condicaopagamentoid);
        await picService.getPicPedidos();
      }
    });

    // Salvamento no LocalStorage
    if (this.$store.getters['auth/IS_LOGGED_IN']) {
      const userId = this.getUserId();
      const savedFormData = localStorage.getItem(`infoPedidoForm_${userId}`);
      if (savedFormData) {
        try {
          const parsedData = JSON.parse(savedFormData);
          this.$store.commit('InfoPedido/SET_FORM_INFO_PEDIDO', parsedData);

          if (parsedData.cliente?.clienteiderp) {
            this.$store.commit('InfoPedido/SET_LOADING_TABELA_PRECO', true);
            await slsTabelapreco.getTabelaPrecoByClienteIdERP(parsedData.cliente.clienteiderp)
              .finally(() => {
                this.$store.commit('InfoPedido/SET_LOADING_TABELA_PRECO', false);
              });
          }

          if (parsedData.cliente?.clienteid
            && parsedData.estabelecimento?.estabelecimentoid
            && parsedData.tabelaPreco?.tabelapreco_id
            && parsedData.condicaoPagamento?.condicaopagamentoid) {
            this.$store.commit('PicStore/SET_FILTERS', {
              estabelecimentoid: parsedData.estabelecimento.estabelecimentoid,
              clienteid: parsedData.cliente.clienteid,
              tabelaprecoId: parsedData.tabelaPreco.tabelapreco_id,
              condicaopagamentoid: parsedData.condicaoPagamento.condicaopagamentoid,
            });
          }
        } catch (error) {
          console.error('Erro ao carregar dados do pedido do localStorage:', error);
        }
      }

      const formData = this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'];
      const isEmpty = !formData.cliente || !formData.cliente.clienteid;

      const perfilLogado = JSON.parse(localStorage.getItem('perfilLogado'));
      const isClienteFinal = perfilLogado && PERFIS_CLIENTE.includes(perfilLogado.perfil_acesso_nome);

      if (isClienteFinal && !this.storeFormCompleto()) {
        console.log('Usuário com perfil Cliente detectado');

        // Carregar dados do cliente associado — só quando o formulário
        // ainda estiver incompleto (fallback). Quando o login/home já deixou
        // tudo carregado, o modal abre pronto, sem "recarregar sozinho".
        setTimeout(async () => {
          try {
            console.log('Carregando dados para perfil ClienteFinal no InfoPedido...');

            const result = await InitialDataService.loadClienteFinalData();
            if (!result || !result.cliente) {
              console.error('Nenhum cliente encontrado para o usuário.');
              return;
            }
            this.formInfoPedido = { ...this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'] };
          } catch (error) {
            console.error('Erro ao carregar dados do cliente final:', error);
          }
        }, 500);
      }
    }

    const { clienteId } = this.$route.params;
    const cachedGetter = this.$store.getters['SLSClienteStore/getCachedInfoPedido'];
    const cachedData = typeof cachedGetter === 'function' ? cachedGetter(clienteId) : cachedGetter;

    if (cachedData) {
      this.clienteInfo = cachedData;
    } else if (clienteId) {
      this.clienteInfo = await slsClienteService.getInfoPedidoByClienteId(clienteId);
    }
  },
};
</script>

<template>
  <b-overlay variant="white" :show="$store.getters['InfoPedido/GET_IS_LOADING']" spinner-variant="primary" blur="0"
    opacity=".75" rounded="sm">
    <b-alert v-if="formBloqueado || bloqueado" show variant="warning" class="mb-3">
      <feather-icon icon="AlertTriangleIcon" class="mr-1" />
      <span>O pedido possui itens no carrinho. Remova todos os itens para alterar as informações.</span>
    </b-alert>
    <b-row>
      <!--  REPRESENTANTE -->
      <b-col cols="12">
        <b-row>
          <b-col v-if="!ocultarInfoComercial" cols="12" md="2">
            <b-form-group label="Representante" label-for="representanteId">
              <b-input-group>
                <b-form-input id="representanteId" placeholder="Código"
                  v-model="formInfoPedido.representante.representanteid" @blur="onChageCodigoRepresentante"
                  @keyup.enter="onChageCodigoRepresentante"
                  :disabled="!canSearchRepresentante" />
                <b-input-group-append>
                  <b-button variant="primary" v-b-modal.modal-buscar-representante @click="loadingRepresentantes"
                    v-b-tooltip.hover title="Abrir lista de representantes"
                    :disabled="!canSearchRepresentante">
                    <feather-icon icon="SearchIcon" />
                    <b-spinner small v-if="getLoadingRepresentante" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col v-if="!ocultarInfoComercial" cols="12" md="4">
            <b-form-group label="Nome Representante" label-for="representanteNome">
              <b-form-input id="representanteNome" disabled placeholder="Nome"
                :value="formInfoPedido.representante.representantenome" />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="2">
            <b-form-group label="Cod. Estabelecimento" label-for="estabelecimentoId">
              <b-form-input id="estabelecimentoId" disabled placeholder="Código"
                :value="formInfoPedido.estabelecimento.estabelecimentoid" />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="4">
            <b-form-group label="Razão Social" label-for="estabelecimentoRazaoSocial">
              <b-form-input id="estabelecimentoRazaoSocial" disabled placeholder="Razão Social"
                :value="formInfoPedido.estabelecimento.estabelecimentorazaosocial" />
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>

      <!--  CLIENTE E CONDICAO PAGAMENTO -->
      <b-col cols="12">
        <b-row>
          <!-- Perfil Cliente não vê o próprio código ERP (só a razão social) -->
          <b-col v-if="!isPerfilCliente" cols="12" md="2">
            <b-form-group label="Cliente" label-for="clienteId">
              <b-input-group>
                <b-form-input id="clienteId" placeholder="Código" :value="clienteIdErpSemZeros"
                  @input="clienteIdErpSemZeros = $event"
                  :disabled="(!canSearchCliente && isClienteFinal) || formBloqueado || bloqueado"
                  @keyup.enter="onChagenCliente" @blur="onChagenCliente" />
                <b-input-group-append>
                  <b-button variant="primary"
                    v-if="canSearchCliente"
                    :disabled="!canSearchCliente" v-b-modal.modal-buscar-cliente-info-pedido
                    v-b-tooltip.hover title="Abrir lista de clientes">
                    <feather-icon icon="SearchIcon" />
                    <b-spinner small v-if="getLoadingCliente" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="4">
            <b-form-group label="Nome Cliente" label-for="clienteRazaoSocial">
              <b-form-input id="disabledInput" disabled placeholder="Nome"
                :value="formInfoPedido.cliente.clienterazaosocial" />
            </b-form-group>
          </b-col>
          <!-- CNPJ em evidência: confirma visualmente que é o cliente certo -->
          <b-col cols="12" md="2">
            <b-form-group label="CNPJ / CPF" label-for="clienteCnpjInfo">
              <b-form-input id="clienteCnpjInfo" disabled placeholder="—"
                :value="cnpjClienteFormatado" />
            </b-form-group>
          </b-col>
          <b-col v-if="!ocultarTabelaCondicao" cols="12" md="2">
            <b-form-group v-if="$store.getters['preferencias/condicaoPagamentoAtiva']" label="Condição de Pagamento" label-for="condicaoPagamentoId">
              <b-input-group>
                <b-form-input
                  id="condicaoPagamentoId"
                  placeholder="Código"
                  v-model="formInfoPedido.condicaoPagamento.condicaopagamentoid"
                  type="number"
                  @keypress="onlyNumber($event)"
                  @keyup.enter="onChangeCondPagtoDebounced"
                  @blur="onChangeCondPagtoDebounced"
                  :disabled="formInfoPedido.representante.representantenome === ''"
                />
                <b-input-group-append>
                  <b-button
                    variant="primary"
                    v-if="formInfoPedido.representante.representantenome !== ''"
                    v-b-modal.modal-buscar-condpgto-info-pedido
                    v-b-tooltip.hover
                    title="Abrir lista de condições de pagamento"
                  >
                    <feather-icon icon="SearchIcon" />
                    <b-spinner small v-if="getLoadingCondPagamento" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col v-if="!ocultarTabelaCondicao" cols="12" md="4">
            <b-form-group v-if="$store.getters['preferencias/condicaoPagamentoAtiva']" label="Descrição Condição de Pagamento" label-for="disabledInput">
              <b-form-input id="disabledInput" disabled
                v-model="formInfoPedido.condicaoPagamento.condicaopagamentodescricao" />
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>

      <!--  TABELA PRECO -->
      <b-col cols="12">
        <b-row>
          <b-col v-if="!ocultarTabelaCondicao" cols="12" md="2">
            <b-form-group label="Tabela de preço" label-for="codTabelaPreco">
              <b-input-group>
                <b-form-input id="codTabelaPreco" placeholder="Código" @keyup.enter="onChageCodigoTabelaPreco"
                  @blur="onChageCodigoTabelaPreco" v-model="formInfoPedido.tabelaPreco.tabelapreco_id"
                  :disabled="formInfoPedido.cliente.clienterazaosocial === '' || disabledInputTabelaPreco || formBloqueado || bloqueado" />
                <b-input-group-append>
                  <b-button variant="primary" v-if="formInfoPedido.cliente.clienterazaosocial !== ''"
                    v-b-modal.modal-buscar-tabelapreco-info-pedido v-b-tooltip.hover
                    title="Abrir lista de tabelas de preço"
                    :disabled="disabledInputTabelaPreco || formBloqueado || bloqueado">
                    <feather-icon icon="SearchIcon" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col v-if="!ocultarTabelaCondicao" cols="12" md="4">
            <b-form-group label="Descrição Tabela" label-for="tabelaprecoDescricao">
              <b-form-input id="tabelaprecoDescricao" disabled
                v-model="formInfoPedido.tabelaPreco.tabelapreco_descricao" />
            </b-form-group>
          </b-col>
          <!-- ID Nexus é opcional e exclusivo de WD. -->

          <b-col v-if="isPedidoDoacaoAtual" cols="12" md="2">
            <b-form-group label="ID Nexus" label-for="idNexus">
              <!-- Sempre editável (mesmo com itens no carrinho): rascunhos antigos
                   não têm ID Nexus e o usuário precisa poder preencher aqui. -->
              <b-form-input
                id="idNexus"
                v-model="formInfoPedido.idNexus"
                :state="idNexusState"
                maxlength="6"
                inputmode="numeric"
                placeholder="000000"
                @input="formInfoPedido.idNexus = String($event || '').replace(/\D/g, '').slice(0, 6)"
              />
              <b-form-invalid-feedback>
                Se informado, use exatamente 6 dígitos numéricos.
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>

      <!-- Tipo de pedido permanece visível enquanto as opções permitidas carregam
           e quando só uma está disponível; nunca ocultar por uma lista transitória. -->
      <b-col v-if="!isPerfilCliente" cols="12">
        <b-row>
          <b-col cols="12" md="4">
            <b-form-group label="Tipo de Pedido" label-for="tipoPedidoSelect">
              <b-form-select
                id="tipoPedidoSelect"
                :value="formInfoPedido.tipoPedidoCliente ? formInfoPedido.tipoPedidoCliente.tipopedidoid : null"
                @change="$store.commit('InfoPedido/SET_TIPO_PEDIDO_CLIENTE', { tipopedidoid: $event, tipopedidodescricao: (getTipoPedidos || []).find(t => t.value === $event) ? (getTipoPedidos || []).find(t => t.value === $event).text : '' })"
                :disabled="formBloqueado || bloqueado || loadingTipoPedidos || !!erroTipoPedidos || !(getTipoPedidos || []).some(t => t && t.value)"
                :options="getTipoPedidos || []"
              />
              <small v-if="loadingTipoPedidos">Carregando tipos de pedido permitidos...</small>
              <small v-if="erroTipoPedidos" class="text-danger">
                {{ erroTipoPedidos }}
                <b-button size="sm" variant="link" @click="$store.dispatch('InfoPedido/carregarTiposPedidoPermitidos')">Tentar novamente</b-button>
              </small>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>

      <div v-if="isLoadingPromocoes" class="d-flex mb-1 ml-1">
        <b-spinner variant="primary" small />
        <p class="ml-1 mb-0 font-weight-bolder">
          Carregando promoções...
        </p>
      </div>

      <!-- PIC do pedido -->
      <div v-if="picAtivo" class="mr-1 ml-1 mb-1">
        <b-button @click="getPromocoes()" variant="primary" :disabled="isLoadingPromocoes || loadingPic">
          <feather-icon icon="SearchIcon" />
          Buscar Promoções
        </b-button>
      </div>

      <!-- PIC do pedido -->
      <!-- <div class="mb-1" v-if="IS_EXIST_PIC">
        <b-input-group>
          <b-input-group-prepend>
            <b-button @click="opemenModalPic()" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="success">
              <feather-icon icon="TagIcon" />
              Ver Promoções
            </b-button>
          </b-input-group-prepend>
          <b-form-input v-if="picSelected" placeholder="Promoção selecionada" :value="picSelected.picdescricao"
            disabled />
        </b-input-group>
      </div> -->

      <!--    OBSERVACAO -->
      <b-col cols="12">
        <div>
          <label for="textarea-default">Observação</label>
          <b-form-textarea id="textarea-default" placeholder="Observação" rows="3"
            :disabled="formBloqueado || bloqueado"
            v-model="formInfoPedido.observacao" />
        </div>
      </b-col>

      <!-- Cliente sem endereço padrão: escolha OBRIGATÓRIA do endereço de entrega
           na seleção do cliente (botão interno oculto; modal aberto via ref) -->
      <escolher-endereco-entrega
        ref="escolherEnderecoObrigatorio"
        style="display: none"
        :value="enderecoAlternativoStore"
        :clienteid="formInfoPedido.cliente && formInfoPedido.cliente.clienteid"
        uf-atual=""
        @input="onEnderecoAlternativoEscolhido"
        @fechado="onEnderecoAlternativoFechado"
      />

      <div class="d-flex justify-content-end mt-2 ml-1">
        <b-button v-if="!isClienteFinal" variant="danger" class="mr-2" @click="limparFormulario" :disabled="formBloqueado || bloqueado"
          :title="(formBloqueado || bloqueado) ? 'Remova todos os itens do carrinho antes de limpar o formulário' : 'Limpar todos os campos'">
          <feather-icon icon="TrashIcon" class="mr-1"></feather-icon>
          Limpar
        </b-button>
      </div>
    </b-row>
  </b-overlay>
</template>

<style scoped lang="scss"></style>
